import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { PrivatesAppointmentsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface IUseAppointmentGetProps {
  id: number;
  enabled?: boolean;
}

export const useAppointmentGet = ({
  id,
  enabled = true,
}: IUseAppointmentGetProps) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending, isFetching, refetch } = useQuery({
    queryKey: [QueryKeys.Appointments, id],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(
        PrivatesAppointmentsApi,
        accessToken,
      );
      return service.getAppointmentById({
        id,
      });
    },
    enabled: enabled && id > 0 && !!accessToken,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    isFetching,
    refetch,
  };
};
